<template>
  <div>
    <!-- 基础使用 -->
    <!-- <el-button type="text"
               @click="dialogVisible1 = true">打开基础DialogReset &nbsp;&nbsp;</el-button>
    <dialog-reset :visible.sync="dialogVisible1"
                  title="DialogReset基础使用示例">
      <div>自定义内容区域</div>
      <span slot="dialog_footer"
            class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </dialog-reset> -->
    <!-- 放大缩小 及 无遮罩层-->

    <div class="padding-20"
         style="color: #409eff;">一. 1.缩放 2.无遮罩层,定义高度和布局位置 3.对话框拖动 <i style="color: #000; font-size: 13px;">1.zoomShow=true 打开缩放功能，2.ask_Dialogdrag=true打开拖动功能 3. modalShow=false 关闭遮罩层 </i>
      <br /> <br />
      <el-button type="text"
                 @click="dialogVisible2 = true"> 打开DialogReset </el-button>
    </div>
    <dialog-reset :visible.sync="dialogVisible2"
                  top='10vh'
                  height="50vh"
                  width="60%"
                  zoomShow
                  :modalShow="false"
                  ask_Dialogdrag
                  title="DialogReset示例2">
      <div v-for="index in 30"
           :key="index"
           style="height:100px">自定义内容区域{{index}}</div>
      <span slot="dialog_footer"
            class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </dialog-reset>
    <br />
    <div>
      <el-collapse v-model="activeNames.DialogResetCode1">
        <el-collapse-item title="@code"
                          name="2">
          <div>
            <prism-editor class="my-editor height-300"
                          :key="DialogResetCode1"
                          v-model="DialogResetCode1"
                          :highlight="highlighter"
                          readonly
                          line-numbers></prism-editor>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <br />
    <!-- 对话框拖动 及 组件嵌套-->
    <div class="padding-20"
         style="color: #409eff;">二. 组件嵌套 *推荐用法 <i style="color: #000; font-size: 13px;"></i>
      <br /> <br />
      <el-button type="text"
                 @click="dialogVisible3 = true">打开DialogReset </el-button>
    </div>
    <dialog-reset :visible.sync="dialogVisible3"
                  top='10vh'
                  height="50vh"
                  ask_Dialogdrag
                  title="DialogReset示例3">
      <dialog-reset-demo-children @callSwitch="dialogVisible3=false"
                                  ref="DialogResetDemoChildren"></dialog-reset-demo-children>
    </dialog-reset>
    <br /> <br />
    <div>
      <el-collapse v-model="activeNames.DialogResetCode2">
        <el-collapse-item title="@code"
                          name="2">
          <div>
            <prism-editor class="my-editor height-300"
                          :key="DialogResetCode2"
                          v-model="DialogResetCode2"
                          :highlight="highlighter"
                          readonly
                          line-numbers></prism-editor>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <br />
    <!-- 对话框组件嵌套2-->
    <div class="padding-20"
         style="color: #409eff;">三.组件嵌套2 <i style="color: #000; font-size: 13px;">showBtn=false用来关闭 自动读取时创建的 DOM ，防止出现幽灵盒子</i>
      <br /> <br />
      <el-button type="text"
                 @click="dialogVisible4 = true"> 打开DialogReset &nbsp;&nbsp;</el-button>
    </div>
    <dialog-reset :visible.sync="dialogVisible4"
                  top='10vh'
                  height="50vh"
                  :slotShow='true'
                  title="DialogReset示例4">
      <dialog-reset-demo-children @callSwitch="dialogVisible4=false"
                                  ref="DialogResetDemoChildren2"
                                  :showBtn='false'></dialog-reset-demo-children>
      <span slot="dialog_footer">
        <el-button @click="callSwitch()">取 消(具名插槽传入)</el-button>
        <el-button type="primary"
                   @click="submitForm()">确 定(具名插槽传入)</el-button>
      </span>
    </dialog-reset>
    <br />
    <div>
      <el-collapse v-model="activeNames.DialogResetCode3">
        <el-collapse-item title="@code"
                          name="2">
          <div>
            <prism-editor class="my-editor height-300"
                          :key="DialogResetCode3"
                          v-model="DialogResetCode3"
                          :highlight="highlighter"
                          readonly
                          line-numbers></prism-editor>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <br />
  </div>
</template>

<script>

import DialogResetDemoChildren from './DialogResetDemoChildren.vue'  //内部嵌入组件
import { Desc, DescMethod } from '../util/demodesc';  //日志及描述说明文件
DescMethod.initialize();
export default {

  components: {
    DialogResetDemoChildren,
    PrismEditor: DescMethod.PrismEditor,
  },
  data() {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      DialogResetCode1: Desc.DialogResetCode1, //DialogReset对话框组件代码片段
      DialogResetCode2: Desc.DialogResetCode2, //DialogReset对话框组件代码片段
      DialogResetCode3: Desc.DialogResetCode3, //DialogReset对话框组件代码片段


      activeNames: {}
    };
  },
  methods: {
    // 外部剧名插槽回调
    callSwitch() {
      this.$refs.DialogResetDemoChildren2.callSwitch()
    },
    // 外部剧名插槽回调
    submitForm() {
      this.$refs.DialogResetDemoChildren2.submitForm()
    }
    ,
    highlighter(code) {
      return DescMethod.highlight(code, DescMethod.languages.js);
    },
    htmlValue(val) {
      return DescMethod.htmlValue(val)
    },
  }
};
</script>

<style scoped lang='scss'>
::v-deep .el-collapse-item__header {
  padding-left: 10px;
  background-color: rgb(247, 247, 247) !important;
}
</style>